import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';

class DeleteUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            loader: false
        };
    }

    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }
    deleteUser = () => {

        this.setState({ error: '', loader: true });
        let UserEmail = this.props.userEmail;
        let UserName = this.props.userName;
        let UserId = this.props.dataId;
        let WholeSaler = this.props.wholesalerName;

        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserEmail, UserName, UserId, WholeSaler })
            };
            return fetch(`/api/user/RemoveWholesalerAccount`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length > 0) {
                            if (apidata[0].status_code == "1") {

                                this.setState({ error: apidata[0].status_message, loader: false });
                                setTimeout(() => {
                                    this.cancelPopup();
                                }, 1800);                                

                            } else {
                                this.setState({ error: apidata[0].status_message, loader: false });
                            }
                        } else {
                            this.setState({ error: 'Whoops, something went wrong. Please try again', loader: false });
                        }
                    }
                    catch (error) {
                        this.setState({ error: 'Error', loader: false });
                    }
                });
        }
        catch (error) {
        }
    }
    cancelPopup = () => {
        this.props.closeDeleteUserPopup();
        this.props.openManageEmailPopup(this.props.dataId, this.props.wholesalerId, this.props.wholesalerName, this.props.activeManageEmailPagin);
    }
    render() {
        const { error } = this.state
        return (
            <div className='tool-section report confirmClose'>
                <div className='popup report-section'>
                    <div className='popup_inner'>

                        <h1>{this.props.titleText}</h1>

                        <div className="pop-btn ungap">
                            {
                                this.state.loader ? (<div className="theme-loader delete-loader"></div>) : null
                            }
                            <button className="btn" onClick={this.deleteUser}>Yes</button>
                            <button className="btn cancel" onClick={this.cancelPopup}>No</button>
                            {error &&
                                <div className={'alert alert-danger delete'}>{error}</div>
                            }

                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default DeleteUser;